<template>
    <!-- style="height: calc(100vh - 44px); overflow: auto;padding-left:4.2%" -->
  <div
    class="right"
    id="ThreeClass"
    ref="tree"
    @scroll="test"
  >
    <div v-for="(pojo, i) in dataList" :key="i" :id="pojo.itid + 'three'">
      <p class="f-s-6 colorHui m-t-05">{{ pojo.itname }}</p>
      <van-row
        class="rightItem m-t-05"
        v-for="(item, index) in pojo.list"
        :key="index"
        @click="goGroup(item)"
        style="background:white"
      >
        <van-col :span="24" class="f-s-16 dataItem">
          <van-tag type="primary" style="background-color: #575960 !important">{{ item.itname }}</van-tag>
          {{ item.title }}
        </van-col>
        <van-col :span="24" class="m-t-05">
          <span class="f-s-6 colorHui">已拼{{ item.pingroupbase }}团</span>
          <van-button size="mini" :style="dataBtnColor(item)" style="border-radius: 0.2rem " class="f-l-r m-t-02" @click="goGroup(item)" v-if="!item.ifSoldOut"
            >{{ payBtnText(item) }}</van-button
          >
          <van-button size="mini" :style="dataBtnColor(item)" style="color: white;background:#888;border:none !important;border-radius: 0.2rem" class="f-l-r m-t-02" @click="goGroup(item)" v-else disabled
            >售罄</van-button
          >
          <span class="colorOrigin f-s-16 f-l-r m-t-02 m-r-8"
            >¥{{ item.pinprice }}</span
          >
          <span class="f-s-6 f-l-r textH colorHui m-t-04 m-r-8"
            >¥{{ item.originalprice }}</span
          >
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";

export default {
  props: {
    dataList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    datafinished: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    active:{
      type:Number,
      default:0
    },
  },
  data() {
    return {
      loading: false,
      finished: false,
    };
  },
  methods: {
    payBtnText(item) {
      if(item.pinstatus == '1'){
        return '查看资料'
      }else if (item.pinstatus == '4'){
        return '免费领取'
      }
      return item.pinnnum + "人拼团";
    },
    dataBtnColor(item){
      if(item.pinstatus == '1'){
        return {background:"linear-gradient(90deg, #FFEADB 0%, #FFEADB 100%, #FF9C57 100%)",color:"#FC801C"}
      }
      return {background:"linear-gradient(90deg, #FD7B11 0%, #FF9546 100%)",color:'white'}
    },
    // 跳转到去拼团界面
    goGroup(item) {
      // if (localStorage.getItem("setToken") == null) {
      //   localStorage.setItem("BIMType", "true");
      //   this.goLogin();
      // } else {
        if (item.pinstatus == "4") {
          let data = {
            pid: item.pid,
            paymentway: 1,
            orderGroupId: null,
          };
          this.Api({
            url: "api/addDatumOrder",
            method: "POST",
            data,
          }).then(() => {
            item.pinstatus = "1";
            Dialog.confirm({
              title: "领取成功",
              message: "资料领取成功,是否现在去查看",
            })
              .then(() => {
                this.$router.push({
                  path: "/lookData",
                  query: {
                    pid: item.pid,
                  },
                });
              })
              .catch(() => {});
          });
        } else if (item.pinstatus == "1") {
          this.$router.push({
            path: "/lookData",
            query: {
              pid: item.pid,
            },
          });
        } else {
          this.$router.push({ path: "/BIMDetials", query: { pid: item.pid } });
        }
      // }
    },
    getScrollTop() {
      for (let i = 0; i < this.dataList.length; i++) {
        let elemTop = document.getElementById(this.dataList[i].itid + "three")
          .offsetTop;
        this.dataList[i].threeScrollTop = elemTop;
      }
      this.$emit("editThreeTop")
      this.$emit("editTwoList", this.dataList);
    },
    test(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      if (
        scrollTop + clientHeight === scrollHeight ||
        scrollTop + clientHeight > scrollHeight
      ) {
        this.$emit("editActive", this.dataList.length - 1);
      } else if (scrollTop <= 17) {
        this.$emit("editActive", 0);
      } else {
        for (let i = 0; i < this.dataList.length; i++) {
          if (
            this.dataList[i].threeScrollTop <= scrollTop + 56 &&
            this.dataList[i + 1].threeScrollTop >= scrollTop + 56
          ) {
            this.$emit("editActive", i);
          }
        }
      }
    },
  },
  watch: {
    dataList: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.length > 0) {
          this.$nextTick(() => {
            this.getScrollTop();
          });
        }
      },
    },
    active(){
      this.$nextTick(() => {
        this.$emit("editThreeTop")
      })
    }
  },
};
</script>

<style scoped>
.rightItem {
  box-shadow: 0rem 0.15rem 0.75rem 0.1rem rgba(0, 6, 22, 0.06);
  border-radius: 0.3rem;
  padding: 0.5rem;
  width: 89%;
}
.dataItem {
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 0.5rem;
}
</style>